import { useMemo } from 'react'

import { useConfigurationContext } from '../context/configurationContext'
import { useMetaModelContext } from '../context/metaModelContext'
import { useNavigationParams } from '../system/useNavigationParams'
import { getApplicationViewReconciliationSpecs } from './helpers'
import { useOperationsContext } from './operationsContext'

export const useApplicationViewReconciliationSpecs = () => {
  const { layer, block } = useNavigationParams()
  const { reconciliationSpecCreateOperations } = useOperationsContext()
  const { layerTopology, blockTopology } = useMetaModelContext()
  const { viewAt } = useConfigurationContext()

  return useMemo(
    () =>
      getApplicationViewReconciliationSpecs({
        reconciliationSpecCreateOperations,
        layer,
        block,
        layerTopology,
        blockTopology,
        viewAt,
      }),
    [
      reconciliationSpecCreateOperations,
      layer,
      block,
      layerTopology,
      blockTopology,
      viewAt,
    ],
  )
}
